import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { serchSelect } from "@/mixins/index";
import { addIncomOfChannle, updateIncomOfChannle, returnIncomOfChannle } from "@/api/dataAll/incomeOfChannle";
import { getadvLocation } from "@/api/dataAll/advLocation";
import { allChannel } from "@/api/aymentsdk/getchancllist";
export default {
  name: "addAppMain",
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      dialogFormVisible: false,
      titleName: "",
      id: "",
      form: {
        game: "",
        platform: "",
        pkg: '',
        channel: '',
        advChannel: '',
        advLocation: '',
        put_revenue: "",
        put_channel: ""
      },
      gameId: "",
      value1: "",
      value2: []
    }, _defineProperty(_ref, "id", ""), _defineProperty(_ref, "rules", {// game: [{ required: true, message: "游戏", trigger: "blur" }],
      // email_list: [{ required: true, message: "请使用英文逗号分隔", trigger: "change" }],
      // parameter: [{ required: true, message: "参数", trigger: "blur" }],
    }), _defineProperty(_ref, "formLabelWidth", "80px"), _ref;
  },
  created: function created() {
    var _this = this;

    this.searchMark = {};
    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
  },
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    },
    objArr: {
      get: function get() {
        if (this.obj) {
          return this.obj;
        }
      },
      set: function set(val) {
        this.$emit("changeObj", obj);
      }
    }
  },
  methods: {
    init: function init(id, num) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$returnIncomOfC, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (num == 1) {
                  _this2.titleName = "新增投放渠道收益";
                  _this2.form = {};
                }

                _this2.id = id;

                if (!(id != 't')) {
                  _context.next = 28;
                  break;
                }

                if (!(num == 2)) {
                  _context.next = 28;
                  break;
                }

                _this2.titleName = "修改投放渠道收益";
                _this2.id = id;
                tid = {
                  id: id
                };
                _context.next = 10;
                return returnIncomOfChannle(tid);

              case 10:
                _yield$returnIncomOfC = _context.sent;
                data = _yield$returnIncomOfC.data;
                _this2.form.game = data.game;
                _this2.form.platform = data.platform;
                _this2.form.advertiser_id = data.advertiser_id;
                _this2.form.channel = data.channel;
                _this2.form.advChannel = data.ad_channel;
                _this2.form.advLocation = data.ad_placement;
                _this2.form.pkg = data.pkg;
                _this2.form.put_channel = data.put_channel;
                _this2.form.put_revenue = data.put_revenue;
                _this2.searchMark = _objectSpread({}, _this2.form);
                _this2.searchMark.ad_channel = data.ad_channel;
                _this2.searchMark.ad_placement = data.ad_placement;
                _this2.searchMark.id = data.id;

                if (_this2.searchMark.advChannel) {
                  delete _this2.searchMark.advChannel;
                }

                if (_this2.searchMark.advLocation) {
                  delete _this2.searchMark.advLocation;
                } // this.searchMark.id = this.form.id


                _this2.$set(_this2.form, _this2.form.game, "");

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    advChannelchange: function advChannelchange(id) {
      var _this3 = this;

      if (id != "") {
        getadvLocation({
          advplatform_id: id
        }).then(function (res) {
          _this3.advLocation = res.data;
          _this3.searchMark.ad_channel = "";

          _this3.advchannels.forEach(function (item) {
            if (item.id == id) {
              _this3.searchMark.ad_channel = item.adv_platform_mark;
              _this3.form.advLocation = "";
              _this3.searchMark.ad_placement = "";
            }
          });
        });
      } else {
        this.form.advLocation = "";
        this.searchMark.ad_placement = "";
        this.searchMark.ad_channel = "";
        this.form.advChannel = "";
        this.advLocation = [];
      }
    },
    advLocationchange: function advLocationchange(id) {
      var _this4 = this;

      if (id != "") {
        this.advLocation.forEach(function (item) {
          if (item.id == id) {
            _this4.searchMark.ad_placement = item.adv_place_mark;
          }
        });
        this.$forceUpdate();
      } else {
        this.searchMark.ad_placement = "";
      }
    },
    putChange: function putChange(val) {
      this.searchMark.put_channel = val;
    },
    revenChange: function revenChange(val) {
      this.searchMark.put_revenue = val;
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this5 = this;

      if (this.titleName == "新增投放渠道收益") {
        this.searchMark.kind = 1;
        addIncomOfChannle(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message); // this.$emit("refreshDataList")

            _this5.resetForm("ruleForm");
          } else {
            Message.warning(res.message);

            _this5.resetForm("ruleForm");
          }
        });
      }

      if (this.titleName == "修改投放渠道收益") {
        updateIncomOfChannle(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message);

            _this5.$emit("refreshDataList");

            _this5.resetForm("ruleForm");
          } else {
            Message.warning(res.message);
          }
        });
      }
    },
    clearData: function clearData() {
      this.form = {};
      this.searchMark = {};
    }
  }
};